import React from 'react';
import {FaTasks} from "react-icons/fa";
import {MdAccessTime} from "react-icons/md";
import {ProgressBar} from "../ProgressBar";
import {getInterpolatedColor, score_palette} from "../color/Palettes";
import {TagGroupDisplay} from "./TagGroupDisplay";

export function QuizStartPage({name, description, questionCount, highscore, tags}) {

    return (
        <div>
            <div className={"row my-2"}  >
                <h4>{name}</h4>
                <p>{description}</p>

                <div className={"col d-flex align-items-center "}>
                    <FaTasks size={18} className={"me-2"} />
                    <label className={"fs-5"}>{questionCount} oppgaver</label>
                </div>
                <div className={"col d-flex align-items-center justify-content-end"}>
                    <MdAccessTime size={18} className={"me-2"}/>
                    <label className={"fs-5"}> {Math.round(questionCount * 10 / 60)} min</label>
                </div>
            </div>

            <p className={"m-0 mt-2 text-muted"}>Highscore</p>
            <ProgressBar progress={highscore} height={30}
                         color={getInterpolatedColor(score_palette, highscore, 0, 100)}/>
            <TagGroupDisplay tags={tags}/>


        </div>

    );


}